var text_field_default = {
  "root": "eT-WU",
  "text": "_8lSpG",
  "input": "srTrR",
  "small": "cREG8",
  "medium": "ZmnNJ",
  "large": "Ozug1",
  "webview": "yVk-S",
  "endAdornment": "oT7bp",
  "shown": "Ji-Uq",
  "value": "_57o4t",
  "spinner": "icds8",
  "spin": "VeybD"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
